import * as services from './service'

const UserModel = {
  namespace: 'dashboard',

  state: {
    carousel_list: [],
  },

  effects: {
    *fetchImgList(_, { call, put }) {
      const response = yield call(services.fetchImgList)
      put({
        type: 'setState',
        payload: {
          carousel_list: response.data,
        },
      })
    }
  },

  reducers: {
    setState(state = {}, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
  },
}

export default UserModel
